import React, { useMemo } from 'react';

import { IPermissionSubjectValues } from 'types/IPermissionSubjects';
import { SCM_TOOLS_CARD_DATA } from 'data/scmToolsCardData';
import { useGetPermissionsQuery } from 'services/permissionsService';
import ErrorLayout from 'components/ErrorLayout';
import Footer from './Footer';
import gearGif from 'assets/gifs/gear.gif';
import Header from './Header';
import isScmToolPermissionPresent from 'utils/isScmToolPermissionPresent';
import Loader from 'components/Loader/Loader';
import styles from './CourseManagementPage.module.scss';
import ToolCard from './ToolCard';

function CourseManagementPage() {
  const { data: userPermissions, error, isLoading } = useGetPermissionsQuery();

  const userPermissionSubjects: Array<IPermissionSubjectValues> =
    useMemo(() => {
      return (
        userPermissions?.data?.map((permission: any) => permission.subject) ||
        []
      );
    }, [userPermissions]);

  if (isLoading) {
    return <Loader />;
  } else if (error) {
    return (
      <ErrorLayout
        title="You are not authorised to view this page!"
        message="You are not allowed to perform this action"
      />
    );
  } else {
    return (
      <>
        <Header />
        <div className="column justify-c align-c">
          <img
            src={gearGif}
            alt="gear-icon"
            className={styles.gearGif}
          />
          <div className="dark text-c">
            <div className="bold h2">Welcome Admin,</div>
            What would you like to work with today?
          </div>
          <div className={styles.toolCards}>
            {SCM_TOOLS_CARD_DATA.map(
              (data) =>
                isScmToolPermissionPresent(
                  data.subjects,
                  userPermissionSubjects
                ) && (
                  <ToolCard
                    title={data.title}
                    to={data.to}
                    icon={data.icon}
                    key={data.title}
                  />
                )
            )}
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default CourseManagementPage;
